<div
  class="hero nordic-blue-900-bg white-text relative overflow-hidden"
  [class.with-booking-widget]="showBookingWidget"
>
  <fin-content-image [imageData$]="backgroundImage$" [fillParent]="true"></fin-content-image>
  <div class="grid-col-12 grid-max-width relative">
    <div class="col-1-12">
      <div class="flex ps-xlarge-t nav-wrapper">
        <div class="flex-1 flex nav-container">
          @if (isCorporate$ | async) {
            <fin-corporate-navigation></fin-corporate-navigation>
          }
        </div>
      </div>
    </div>
    <div class="col-1-12">
      <h2 class="ms-medium-b">{{ title }}</h2>
      <span class="font-body-1 medium-type">{{ description }}</span>
      <div class="ps-medium-t">
        <fcom-button
          *ngIf="showLoginButton$ | async"
          data-testid="login-button"
          [text]="'CORPORATE.corporatePortal.logIn' | finLocalization"
          [theme]="ButtonTheme.DARK_PRIMARY_NORDIC_BLUE"
          [icon]="{
            name: SvgLibraryIcon.ARROW_RIGHT,
            position: IconPosition.RIGHT,
          }"
          (clickBtn)="openLogin()"
        ></fcom-button>
      </div>
    </div>
  </div>
</div>
@if (showBookingWidget && (isCorporate$ | async)) {
  <div class="booking-widget-wrapper relative">
    <fin-booking-widget [compactMode]="true" [headingLevel]="2"> </fin-booking-widget>
  </div>
}
